// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".app__Administration__mailingTitle{border-bottom:2px solid #999}.app__Administration__locationTitle{padding-top:17px}", "",{"version":3,"sources":["webpack://./../common/capabilities-react/twia-capability-agencyadmin-react/pages/Administration/Administration.module.scss"],"names":[],"mappings":"AAAA,mCACI,4BAAA,CAGJ,oCACG,gBAAA","sourcesContent":[".mailingTitle {\n    border-bottom: 2px solid #999;\n  }\n  \n.locationTitle {\n   padding-top: 17px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mailingTitle": "app__Administration__mailingTitle",
	"locationTitle": "app__Administration__locationTitle"
};
export default ___CSS_LOADER_EXPORT___;
